import React from "react";
import { Button } from '@mui/material';

export default function ModalFooter(props){
    return (
        <div className='modalFooter'>
            {
                props.buttons.map( button => <Button variant="contained" color={button.color} onClick={button.datas ? () => button.function(button.datas) : button.function} disabled={button.disabled}>{button.text}</Button>)
            }
        </div>
    )
}